/* Rquiere de mixin.js */

var clientPriceList = {
	data () {
		return {
			listClientPriceLists: [],
			methodsClientPriceList: {
                base: 'client/',
				get: 'priceLists',
				show: '/priceList/',
				delete: '/delete',
			},
			paginationClientPriceLists: [],
			searchClientPriceLists: '',
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
        deleteClientPriceList(item) {
            this.axiosActionIS(this.apiBackend + this.methodsClientPriceList.base + item.client_id + this.methodsClientPriceList.show + item.price_list_id + this.methodsClientPriceList.delete, 'DELETE', 'deleteClientPriceListResult')
        },
        deleteClientPriceListResult(reseponse) {
            this.deleteClientPriceListResultLocal(reseponse)
        },
        deleteClientPriceListResultLocal(response) {
            console.log('deleteClientPriceListResult', response)
        }
	},
};

export default clientPriceList;